import { action, Action } from 'typesafe-actions'

import { Anexo, ContrachequeDocumentosTypes, S3Type } from './types'

export const setAnexosContracheque = (payload: Anexo): Action =>
  action(ContrachequeDocumentosTypes.SET_ANEXOS_CONTRACHEQUE, payload)

export const deleteAnexoContracheque = (payload: number): Action =>
  action(ContrachequeDocumentosTypes.DELETE_ANEXO_CONTRACHEQUE, payload)

export const setIsDoneContracheque = (payload: boolean): Action =>
  action(ContrachequeDocumentosTypes.SET_IS_DONE_CONTRACHEQUE, payload)

export const setIsLoadingContracheque = (payload: boolean): Action =>
  action(ContrachequeDocumentosTypes.SET_IS_LOADING_CONTRACHEQUE, payload)

export const setIsErrorContracheque = (payload: boolean): Action =>
  action(ContrachequeDocumentosTypes.SET_IS_ERROR_CONTRACHEQUE, payload)

export const sendToS3Contracheque = (payload: S3Type): Action =>
  action(ContrachequeDocumentosTypes.SEND_TO_S3_SAGA_CONTRACHEQUE, payload)

export const setRollbackRouterErrorContracheque = (payload: string | number | undefined): Action =>
  action(ContrachequeDocumentosTypes.SET_ROLLBACK_ROUTER_ERROR_CONTRACHEQUE, payload)
